// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { checkoutReviewAndSubmitStyle } from "@keller/Overrides/Widgets/CheckoutReviewAndSubmit/checkoutReviewAndSubmit.shared.styles";
import { orderInformationStyles } from "@keller/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { hideElementOnPrint, mergeWithCss } from "@keller/XDL/Utilities";
import { css } from "styled-components";

const gridItem: GridItemProps = {
    ...mergeWithCss(orderInformationStyles.gridItem, {
        css: css`
            @media print {
                padding: 0;
                flex: 0 0 auto;
                width: auto;
            }
        `,
    }),
};

orderInformationStyles.orderDetailsGridContainer = {
    ...mergeWithCss(orderInformationStyles.orderDetailsGridContainer, {
        css: css`
            & ${GridOffset} {
                @media print {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0 20px;
                    padding-left: 8px;
                }
            }
        `,
    }),
};

orderInformationStyles.gridItem = {
    ...gridItem,
};

orderInformationStyles.shippingMethodgridItem =
    orderInformationStyles.requestedDeliveryDateGridItem =
    orderInformationStyles.doNotShipBeforeDateGridItem =
    orderInformationStyles.creditCardGridItem =
    orderInformationStyles.purchaseOrderGridItem =
    orderInformationStyles.releaseNumberGridItem =
    orderInformationStyles.pickUpDateGridItem =
        {
            ...mergeWithCss(gridItem, {
                css: css`
                    display: none;
                    @media print {
                        display: inline-flex;
                    }
                `,
            }),
        };

orderInformationStyles.labelName = {
    headingTextGridItem: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
};

orderInformationStyles.orderNotesOnPrint = {
    width: 12,
    css: css`
        display: none;
        @media print {
            display: flex;
            padding: 0;
        }
    `,
};
